import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import * as R from 'remeda';
import { suggestionActions } from 'store/data/suggestion';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Persists a Data.Suggestion to the API and adds the server-assigned entity
// to the suggestion domain. Returns the created Data.Suggestion so callers
// can act on its server-assigned ID. toSuggestion may return undefined if
// the response is missing required fields — guard before dispatching.
export function* createSuggestion(args: { suggestion: Data.Suggestion }) {
  const { suggestion } = args;

  function* work(tenantId: string) {
    const {
      suggestion: createdSuggestion,
    }: SagaReturnType<typeof api.createSuggestion> = yield call(
      api.createSuggestion,
      { tenantId, suggestion },
    );

    if (!R.isDefined(createdSuggestion)) return;

    yield put(suggestionActions.add(createdSuggestion));
    return createdSuggestion;
  }

  return (yield call(operationWrapper, work, JwtFeature.Improvements)) as
    | Data.Suggestion
    | undefined;
}
